// extracted by mini-css-extract-plugin
export default {"review__payment":"BillingReview_review__payment__AquHu","review__payment--config":"BillingReview_review__payment--config__Ax5cg"};